/* eslint-disable no-unused-vars */
import React from "react";

// eslint-disable-next-line react/prop-types
function OperationStructure({ width = 16, height = 16 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 14.575 16"
    >
      <g
        id="Group_5124"
        data-name="Group 5124"
        transform="translate(-32.046 -593)"
      >
        <path
          id="Path_8988"
          data-name="Path 8988"
          d="M418.112,12.824a1.412,1.412,0,1,0-1.412-1.412A1.412,1.412,0,0,0,418.112,12.824Z"
          transform="translate(-378.727 583)"
          fill="#8c8c8c"
        />
        <path
          id="Path_8989"
          data-name="Path 8989"
          d="M297.271,211.2H296.5l-.658,1.074-.655-1.074h-.744c-2.029.036-1.957,1.523-1.957,1.523V216.2h0v.028a.6.6,0,0,0,1.192,0,.076.076,0,0,0,0-.028h0v-3.213h.374l-.007,10.121a.8.8,0,1,0,1.61,0v-6.532h.359v6.541l.007.007a.8.8,0,0,0,1.6-.011l0-10.143h.389v3.236a.6.6,0,1,0,1.195,0v-3.48C299.065,211.172,297.271,211.2,297.271,211.2Z"
          transform="translate(-256.535 385.086)"
          fill="#8c8c8c"
        />
        <path
          id="Path_8990"
          data-name="Path 8990"
          d="M756.438,184.781a.94.94,0,1,0-.939-.94A.94.94,0,0,0,756.438,184.781Z"
          transform="translate(-711.996 412.923)"
          fill="#8c8c8c"
        />
        <path
          id="Path_8991"
          data-name="Path 8991"
          d="M725.759,316.6h-.514l-.437.718-.437-.718h-.5a1.994,1.994,0,0,0-.473.062v1.128h.212l0,6.729a.535.535,0,1,0,1.071,0v-4.341h.242v4.346l0,0a.532.532,0,0,0,1.064,0v-6.747h.261v2.152a.4.4,0,1,0,.79,0v-2.313C726.954,316.588,725.759,316.6,725.759,316.6Z"
          transform="translate(-680.42 281.405)"
          fill="#8c8c8c"
        />
        <path
          id="Path_8992"
          data-name="Path 8992"
          d="M130.338,182.477a.939.939,0,1,0-.939-.937A.938.938,0,0,0,130.338,182.477Z"
          transform="translate(-96.116 415.185)"
          fill="#8c8c8c"
        />
        <path
          id="Path_8993"
          data-name="Path 8993"
          d="M56.266,314l-.438.715L55.394,314H54.88s-1.193-.015-1.28,1.017v2.313a.4.4,0,0,0,.79,0v0h0V315.18h.258l0,6.744a.532.532,0,0,0,1.064,0l0,0v-4.346h.242l0,4.344a.535.535,0,0,0,1.071,0l0-6.732h.209V314.06a1.937,1.937,0,0,0-.47-.06h-.495Z"
          transform="translate(-21.554 283.963)"
          fill="#8c8c8c"
        />
      </g>
    </svg>
  );
}

export default OperationStructure;
